import React from "react";
import { Box, Paper, Typography } from "@material-ui/core";

const AssistedAffiliationRncScreen = () => (
  <Box p={3}>
    <Paper elevation={1}>
      <Box p={3}>
        <Typography variant="h5" component="h2" gutterBottom>
          Afiliación Asistida RNC
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Módulo de gestión de afiliaciones asistidas de comercios RNC.
        </Typography>
      </Box>
    </Paper>
  </Box>
);

export default AssistedAffiliationRncScreen;
